import Layout from '@/layout/ezpay-index.vue'
// import i18n from '@/lang'

export const systemRouter = {
  path: '/systemManage',
  component: Layout,
  redirect: '/systemManage/settings',
  name: 'System_Manage',
  meta: { title: 'system_manage', icon: 'system' },
  children: [
    {
      path: 'mchUsers',
      name: 'System_User_List',
      component: () => import('@/views/ezpay/system/system-user-list'),
      meta: {
        title: 'user_list', noCache: false,
        auth: ['AUTH_CODE_SYS_ADM']
      }
    },
    {
      path: 'mchRoles',
      name: 'System_Role_List',
      component: () => import('@/views/ezpay/system/system-role-list'),
      meta: {
        title: 'role_list', noCache: false,
        auth: ['AUTH_CODE_ROLE_ADM']
      }
    },
  ]
}
